import React from "react";
import { useSettingsActions } from "./SettingsStore.tsx";
import { isBucketOfTens } from "../FactRanges.ts";

/**
 * One toggle per number in a range. These are native checkboxes, not
 * PrimeReact's: there are twenty on the generator's first screen, and each
 * PrimeReact control costs a prop merge on every render of the panel, which was
 * the largest part of the work after a setting change (ADR 0078). The chip
 * looks the same either way, because PrimeReact's own box was already hidden
 * (see `.checkbox` in Settings.css).
 */
export function CheckBoxes(props) {
    const {getSettings, setSettings} = useSettingsActions();
    let checkboxes: JSX.Element[] = [];
    for (let i = 0; i < props.numberRange.length; i++) {
        const value = props.numberRange[i];
        const checked = props.numberSelection.includes(value) ? true : false;
        const text = isBucketOfTens(props.numberRange) ? value + 's' : String(value);
        // Unique across both value ranges, so htmlFor points at one input.
        const inputId = `range-${props.rangeGroup}-value-${value}`;
        checkboxes.push(
            <div key={i} className='checkbox'>
                <label htmlFor={inputId}>{text}</label>
                <input
                    type='checkbox'
                    id={inputId}
                    name={value}
                    checked={checked}
                    onChange={(e) => handleNumberRangeCheckboxSelect(e, props.rangeGroup, getSettings(), setSettings)
                }/>
            </div>
        );
    }
    return checkboxes;
}

function handleNumberRangeCheckboxSelect(e, rangeGroup, settings, setSettings) {
    let updatedSettings = {...settings};
    let range = updatedSettings.NumberRanges.filter(x => x.Id === rangeGroup)[0];
    range.NumberRangeSelection =
        e.target.checked ?
        [...range.NumberRangeSelection, parseInt(e.target.name)] :
        range.NumberRangeSelection.filter((number: number) => number !== parseInt(e.target.name));
    setSettings(updatedSettings);
}
